import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M15.5 22H8.5C7.122 22 6 20.879 6 19.5V2.5C6 2.224 6.224 2 6.5 2C6.776 2 7 2.224 7 2.5V19.5C7 20.327 7.673 21 8.5 21H15.5C16.327 21 17 20.327 17 19.5V6.5C17 5.673 16.327 5 15.5 5H9C8.724 5 8.5 4.776 8.5 4.5C8.5 4.224 8.724 4 9 4H15.5C16.879 4 18 5.122 18 6.5V19.5C18 20.879 16.879 22 15.5 22Z"
      fill="currentColor"
    />
    <path
      d="M15.3161 14H8.68408C8.40808 14 8.18408 13.776 8.18408 13.5C8.18408 12.359 8.73808 11.212 9.63108 10.507C9.84908 10.336 10.1631 10.372 10.3331 10.589C10.5031 10.806 10.4671 11.12 10.2501 11.291C9.72308 11.708 9.35608 12.334 9.23108 13H14.7681C14.6411 12.334 14.2691 11.695 13.7501 11.286C13.5331 11.115 13.4961 10.801 13.6671 10.584C13.8381 10.367 14.1531 10.332 14.3691 10.501C15.2621 11.205 15.8161 12.355 15.8161 13.5C15.8161 13.776 15.5931 14 15.3161 14V14ZM12.0271 10.665C10.7371 10.665 9.68808 9.61601 9.68808 8.32601C9.68808 7.03601 10.7371 5.98901 12.0271 5.98901C13.3181 5.98901 14.3671 7.03701 14.3671 8.32601C14.3671 9.61601 13.3171 10.665 12.0271 10.665ZM12.0271 6.98901C11.2891 6.98901 10.6881 7.58901 10.6881 8.32601C10.6881 9.06501 11.2891 9.66501 12.0271 9.66501C12.7651 9.66501 13.3671 9.06401 13.3671 8.32601C13.3671 7.58801 12.7661 6.98901 12.0271 6.98901V6.98901Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'Video');

export default Icon;
